var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 30,
    viewBox: "0 0 120 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3974 19.9181C47.0994 22.6082 44.4309 23.677 41.7256 23.677C36.6112 23.677 32.5344 20.0283 32.5344 15.2369C32.5344 10.4823 36.4259 6.79681 41.5403 6.79681C44.2459 6.79681 46.9141 7.86561 49.2118 10.556L45.8024 12.9519C44.5791 11.2197 43.1709 10.5192 41.5403 10.5192C38.9088 10.5192 36.7594 12.6202 36.7594 15.2369C36.7594 17.8905 39.0941 19.9546 41.7256 19.9546C43.3562 19.9546 44.8018 19.2547 46.0618 17.6693L49.3974 19.9181Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.2859 23.3456H55.5479V0.199188H51.2859V23.3456Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.8139 20.1021C69.4821 20.1021 71.928 17.9642 71.928 15.2369C71.928 12.5096 69.4821 10.3717 66.8139 10.3717C64.1083 10.3717 61.6995 12.5096 61.6995 15.2369C61.6995 17.9642 64.1083 20.1021 66.8139 20.1021ZM66.8139 6.79681C71.928 6.79681 76.0051 10.4823 76.0051 15.2369C76.0051 19.9918 71.928 23.677 66.8139 23.677C61.6995 23.677 57.5859 19.9918 57.5859 15.2369C57.5859 10.4823 61.6995 6.79681 66.8139 6.79681Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3285 7.12851H80.3317L84.3714 15.79L88.7447 7.12851H93.3776L84.3714 24.341L75.3285 7.12851Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.491 12.9887C104.861 11.5145 103.453 10.3717 101.526 10.3717C99.6359 10.3717 98.0792 11.404 97.3009 12.9887H105.491ZM108.16 21.5028C106.529 22.8665 104.268 23.677 101.897 23.677C96.7821 23.677 92.6686 19.9918 92.6686 15.2369C92.6686 10.4823 96.4115 6.79681 101.526 6.79681C106.64 6.79681 109.976 10.4823 109.976 15.2369V16.4531H96.9303C97.5233 18.591 99.5986 20.1021 101.897 20.1021C103.305 20.1021 104.528 19.6598 105.639 18.5173L108.16 21.5028Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.066 14.2418C112.066 10.3717 115.03 7.12851 119.848 7.12851V10.9246C117.773 10.9246 116.291 12.1779 116.291 14.7581V23.3456H112.066V14.2418Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2118 7.76325C13.2118 4.15731 10.2526 1.23318 6.60441 1.23318C2.95706 1.23318 0 4.15731 0 7.76325C0 11.3692 2.96 14.2965 6.60912 14.2965H13.2118V7.76325Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1144 7.76325C15.1144 4.15731 18.0732 1.23318 21.7217 1.23318C25.3691 1.23318 28.3261 4.15731 28.3261 7.76325C28.3261 11.3692 25.3661 14.2965 21.717 14.2965H15.1144V7.76325Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1135 22.7185C15.1135 26.3279 18.0715 29.25 21.7215 29.25C25.3671 29.25 28.3253 26.3279 28.3253 22.7185C28.3253 19.1126 25.3632 16.1887 21.7153 16.1887H15.1135V22.7185Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.60468 27.4076C9.22644 27.4076 11.3597 25.3042 11.3597 22.7185V18.0315H6.61085C3.98791 18.0315 1.8538 20.134 1.8538 22.7185C1.8538 25.3042 3.98497 27.4076 6.60468 27.4076ZM13.2126 22.7185C13.2126 26.3279 10.2544 29.25 6.60468 29.25C2.95909 29.25 0.000854492 26.3279 0.000854492 22.7185C0.000854492 19.1126 2.96262 16.1887 6.61085 16.1887H13.2126V22.7185Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "assets/media/logo.e3be78aeeda2e0886846f4ea9aa73aad.svg";
export { ForwardRef as ReactComponent };